export const TEST_ID = 'detailsViewCardHeaderDropdownMenuItem';
